// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueRouter from 'vue-router';
import iView from 'iview';
import VueResource from 'vue-resource'
import protocol from './assets/js/trans/protocol.js'
import http from './assets/js/trans/http.js'
import util from './assets/common/util.js'
import 'iview/dist/styles/iview.css';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import axios from './config/httpConfig'
import store from './store'
import 'babel-polyfill'
import './assets/iconfont/iconfont.css';
/* import '../my-theme/index.less';  */
import VueLazyload from "vue-lazyload";

global.protocol = protocol
global.http = http
global.util = util
Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.use(VueRouter);
Vue.use(iView);
Vue.use(ElementUI);
Vue.use(VueResource);
Vue.use(VueLazyload);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})

//路由跳转后返回页面顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})



// WEBPACK FOOTER //
// ./src/main.js